export const CoinIcon = () => (
	<div className="reward-coin__icon">
		<i className="reward-iconcolor-shop-coin" />
	</div>
);